module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GYZ_3X.d7b4f93b.tom";